import React, { useEffect } from 'react';
import { Alert, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface AutoDismissAlertProps {
  open: boolean;
  onClose: () => void;
  severity?: 'error' | 'warning' | 'info' | 'success';
  title: string;
  message: string | React.ReactNode;
  duration?: number; // in ms, default 10000 (10 seconds)
}

const AutoDismissAlert: React.FC<AutoDismissAlertProps> = ({
  open,
  onClose,
  severity = 'error',
  title,
  message,
  duration = 10000,
}) => {
  useEffect(() => {
    if (open) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [open, onClose, duration]);

  if (!open) return null;

  return (
    <Alert
      variant="filled"
      severity={severity}
      action={
        <IconButton aria-label="close" color="inherit" size="small" onClick={onClose}>
          <CloseIcon fontSize="inherit" />
        </IconButton>
      }
      sx={{ mb: '16px' }}
    >
      <Typography fontWeight={500}>{title}</Typography>
      <Typography fontWeight={400} fontSize={14}>
        {message}
      </Typography>
    </Alert>
  );
};

export default AutoDismissAlert;
